import { useId } from "react";

/**
 * LiqoMark — il marchio ufficiale "Gradient Bracketed L".
 * Una "L" con gradiente verticale bianco -> mint (#00FF87) racchiusa tra parentesi [ ] mint.
 * Vettoriale: nitido a qualsiasi dimensione. Usato in Login e header (lo splash NON lo usa).
 *
 * Props:
 *  - size: lato in px (default 64)
 *  - withBackground: mostra il tile scuro squircle dietro (per anteprime/icona)
 *  - glow: aggiunge un alone mint (per il login)
 */
export const LiqoMark = ({ size = 64, withBackground = false, glow = false, className = "", ...props }) => {
  const gid = useId();
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 100 100"
      fill="none"
      role="img"
      aria-label="Liqo"
      className={className}
      style={glow ? { filter: "drop-shadow(0 0 14px rgba(0,255,135,0.28))" } : undefined}
      {...props}
    >
      <defs>
        <linearGradient id={gid} gradientUnits="userSpaceOnUse" x1="48" y1="26.8" x2="48" y2="74.4">
          <stop offset="0" stopColor="#FFFFFF" />
          <stop offset="0.38" stopColor="#EAFFF4" />
          <stop offset="1" stopColor="#00FF87" />
        </linearGradient>
      </defs>

      {withBackground && <rect x="0" y="0" width="100" height="100" rx="27" fill="#0B0B11" />}

      {/* parentesi [ ] */}
      <g fill="#00FF87">
        <rect x="25" y="30.8" width="3.8" height="40.4" />
        <rect x="25" y="30.8" width="9.2" height="4" />
        <rect x="25" y="67.2" width="9.2" height="4" />
        <rect x="71.2" y="30.8" width="3.8" height="40.4" />
        <rect x="65.8" y="30.8" width="9.2" height="4" />
        <rect x="65.8" y="67.2" width="9.2" height="4" />
      </g>

      {/* L con gradiente */}
      <g fill={`url(#${gid})`}>
        <rect x="41.8" y="26.8" width="13.8" height="47.6" />
        <rect x="41.8" y="67.2" width="21" height="7.2" />
      </g>
    </svg>
  );
};
